// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__Wegnp","viewnet":"HeaderSimple_viewnet__LpUit"};